import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TTradeDetailsById } from "../types/trades/trades";
import moment from "moment";
import { numberPrecision } from "../helpers/getText";

export type TAddPattiDetails = {
  pattiDate: string;
  delayCharges: number;
  pattiAmt: number;
  commPerVal: number;
  comm: number;
  lbrCharges: number;
  misc: number;
  pfPer: number;
  pf: number;
  dis: number;
  freightPaid: number;
  advancePaidReceive: number;
  totalPaidReceive: number;
  finalPaidReceive: number;
  otherCharges: number;
  mandiFee: number
};

type TInitialState = {
  addSrcPattiDetails: TAddPattiDetails;
  addDestPattiDetails: TAddPattiDetails;
};

const initialState: TInitialState = {
  addSrcPattiDetails: {
    pattiDate: "",
    delayCharges: 0,
    pattiAmt: 0,
    commPerVal: 0,
    comm: 0,
    lbrCharges: 0,
    misc: 0,
    pfPer: 0,
    pf: 0,
    dis: 0,
    freightPaid: 0,
    advancePaidReceive: 0,
    totalPaidReceive: 0,
    finalPaidReceive: 0,
    otherCharges: 0,
    mandiFee: 0
  },
  addDestPattiDetails: {
    pattiDate: "",
    delayCharges: 0,
    pattiAmt: 0,
    commPerVal: 0,
    comm: 0,
    lbrCharges: 0,
    misc: 0,
    pfPer: 0,
    pf: 0,
    dis: 0,
    freightPaid: 0,
    advancePaidReceive: 0,
    totalPaidReceive: 0,
    finalPaidReceive: 0,
    otherCharges: 0,
    mandiFee: 0
  },
};

export const pattiDetails = createSlice({
  name: "pattiDetails",
  initialState: initialState,
  reducers: {
    resetArrivalDetails: (state) => {
      return {
        ...initialState,
      };
    },

    setAddSrcPatti: (
      state,
      action: PayloadAction<{
        tradeDetail: TTradeDetailsById;
      }>
    ) => {
      let tradeDetail = action.payload.tradeDetail;

      state.addSrcPattiDetails.pattiDate = tradeDetail?.pattiDate
        ? tradeDetail?.pattiDate
        : '';
      state.addSrcPattiDetails.pattiAmt = Number(tradeDetail?.pattiAmt);
      state.addSrcPattiDetails.commPerVal = parseFloat(
        (
          (Number(tradeDetail?.comm) * 100) /
          Number(tradeDetail?.pattiAmt)
        ).toFixed(2)
      );
      state.addSrcPattiDetails.comm = Number(tradeDetail?.comm);
      state.addSrcPattiDetails.lbrCharges = Number(tradeDetail?.lbrCharges);
      state.addSrcPattiDetails.otherCharges = Number(tradeDetail?.otherCharges);
      state.addSrcPattiDetails.mandiFee = Number(tradeDetail?.mandiFee);
      state.addSrcPattiDetails.misc = Number(tradeDetail?.misc);
      state.addSrcPattiDetails.totalPaidReceive = Number(
        tradeDetail?.totalReceivable
      );
      state.addSrcPattiDetails.pfPer = numberPrecision(
        (Number(tradeDetail?.srcPf) * 100) / Number(tradeDetail?.pattiAmt));
      state.addSrcPattiDetails.pf = Number(tradeDetail?.srcPf);
      state.addSrcPattiDetails.dis = Number(tradeDetail?.srcDis);
      // state.addSrcPattiDetails.advancePaidReceive = Number(calculateAdvancePaidSrc(tradeDetail?.pmtHistory));
      state.addSrcPattiDetails.advancePaidReceive = Number(tradeDetail?.srcAdv);
      state.addSrcPattiDetails.freightPaid = Number(tradeDetail?.freightPaid);
      state.addSrcPattiDetails.finalPaidReceive =
        Number(tradeDetail?.totalReceivable) -
        Number(tradeDetail?.srcPf) +
        Number(tradeDetail?.srcDis);
    },

    setAddDestPatti: (
      state,
      action: PayloadAction<{
        tradeDetail: TTradeDetailsById;
      }>
    ) => {
      let tradeDetail = action.payload.tradeDetail;

      state.addDestPattiDetails.pattiDate = tradeDetail?.pattiDate
        ? tradeDetail?.pattiDate
        : '';
      state.addDestPattiDetails.delayCharges = tradeDetail?.destDelayCharges;
      state.addDestPattiDetails.pattiAmt = Number(tradeDetail?.pattiAmt);
      state.addDestPattiDetails.commPerVal = parseFloat(
        (
          (Number(tradeDetail?.comm) * 100) /
          Number(tradeDetail?.pattiAmt)
        ).toFixed(2)
      );
      // state.addDestPattiDetails.advancePaidReceive = Number(calculateAdvancePaid(tradeDetail?.pmtHistory))
      state.addDestPattiDetails.advancePaidReceive = Number(tradeDetail?.destAdv)
      state.addDestPattiDetails.freightPaid = Number(tradeDetail?.freightPaid);
      state.addDestPattiDetails.comm = Number(tradeDetail?.comm);
      state.addDestPattiDetails.lbrCharges = Number(tradeDetail?.lbrCharges);
      state.addDestPattiDetails.otherCharges = Number(tradeDetail?.otherCharges);
      state.addDestPattiDetails.mandiFee = Number(tradeDetail?.mandiFee);
      state.addDestPattiDetails.misc = Number(tradeDetail?.misc);
      state.addDestPattiDetails.totalPaidReceive = Number(
        tradeDetail?.totalPayable
      );
      state.addDestPattiDetails.pfPer = numberPrecision(
        (Number(tradeDetail?.destPf) * 100) / Number(tradeDetail?.pattiAmt));
      state.addDestPattiDetails.pf = Number(tradeDetail?.destPf);
      state.addDestPattiDetails.dis = Number(tradeDetail?.destDis);
      state.addDestPattiDetails.finalPaidReceive =
        Number(tradeDetail?.totalPayable) +
        Number(tradeDetail?.destPf) -
        Number(tradeDetail?.destDis);
    },

    udpateAddSrcPatti: (
      state,
      action: PayloadAction<{
        srcPatti: TAddPattiDetails;
      }>
    ) => {
      state.addSrcPattiDetails = action.payload.srcPatti;
    },
    udpateAddDestPatti: (
      state,
      action: PayloadAction<{
        destPatti: TAddPattiDetails;
      }>
    ) => {
      state.addDestPattiDetails = action.payload.destPatti;
    },
  },
});

export const {
  setAddSrcPatti,
  setAddDestPatti,
  udpateAddSrcPatti,
  udpateAddDestPatti,
} = pattiDetails.actions;
export default pattiDetails.reducer;
